// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterCircleFilledSvg from "@ant-design/icons-svg/es/asn/TwitterCircleFilled";
import AntdIcon from '../components/AntdIcon';

var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterCircleFilledSvg
  }));
};

TwitterCircleFilled.displayName = 'TwitterCircleFilled';
export default /*#__PURE__*/React.forwardRef(TwitterCircleFilled);